import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { Map } from 'immutable';

export const customerSubscriptions$ = pathSubscription(['notifications', 'customer']);

export const subscriptionsSettingsTicketTracking$ = pathSubscription(
    ['notifications', 'settings', 'ticketTracking'],
    false
);

export const subscriptionsSettingsPicksTracking$ = pathSubscription(
    ['notifications', 'settings', 'picksTracking'],
    false
);

export const subscribedTicketIds$ = subscription(db => db.getIn(['notifications', 'tickets'], Map()).keySeq());

export const ticketSubscriptions$ = ticketId => pathSubscription(['notifications', 'tickets', ticketId], Map());

export const subscribed$ = parametric(ticketId =>
    subscription(subscribedTicketIds => {
        return subscribedTicketIds && subscribedTicketIds.includes(ticketId);
    }, subscribedTicketIds$)
);

export const subscribedMatchMap$ = pathSubscription(['notifications', 'match']);

export const matchSubscriptions$ = eventId => pathSubscription(['notifications', 'match', eventId]);

export const matchSubscriptionTypes$ = eventId => pathSubscription(['notifications', 'match', eventId, 'types']);

export const matchNotificationTypes$ = eventId => pathSubscription(['notifications', 'types', 'match', eventId]);

export const minimalTicket$ = ticketId => pathSubscription(['ticketus', 'minimal', ticketId]);

export const betbookSubscription$ = authorNickname => pathSubscription(['notifications', 'betbook', authorNickname]);
